/**
 * JSON serialization support for ImageOrigin
 */

import { z } from 'zod';
import type { ImageOrigin } from './ImageOrigin';

/**
 * Zod schema for ImageOrigin
 */
export const ImageOriginSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('data'),
    value: z.string()
  }),
  z.object({
    type: z.literal('url'),
    value: z.string()
  }),
  z.object({
    type: z.literal('file'),
    value: z.string()
  }),
  z.object({
    type: z.literal('svg'),
    value: z.string()
  })
]);

/**
 * Convert ImageOrigin to JSON
 */
export function imageOriginToJSON(origin: ImageOrigin): unknown {
  return {
    type: origin.type,
    value: origin.value
  };
}
